import { createContext } from 'react'

// DOM node of the generic side-panel slot rendered by `PageWithWidgets`;
// page content portals its panels (e.g. the emails thread preview) into it.
export const PageSidePanelContainer = createContext(null)
